const LocationPinIcon = () => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden
  >
    <ellipse cx="6" cy="6.00026" rx="6" ry="6.00026" fill="white" />
    <ellipse cx="6" cy="6.00013" rx="3" ry="3.00013" fill="white" />
    <path d="M6.14527 17.9972L10.8004 9.59848L1.20036 9.59848L6.14527 17.9972Z" fill="white" />
    <circle cx="6" cy="6" r="3" fill="black" />
  </svg>
);

export default LocationPinIcon;
